import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { supabase } from "../../../supabase";
import Loading from "../../components/Loading/Loading";
import { getUserById, setSessionUser, setUser } from "../../Reducers/actions/authActions";
import { finishGoogleAuth } from "./googleAuth";

export default function GoogleAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const handleGoogleCallback = async () => {
      const code = searchParams.get("code");
      const next = searchParams.get("next") || "/";

      const payload = await finishGoogleAuth({ code, next });
      if (!isMounted) return;

      if (!payload.success) {
        setError(payload.message);
        return;
      }

      const { session, user, isNewUser, next: nextFromApi } = payload.data;
      const nextFromQuery = searchParams.get("next");

      const { error: sessionError } = await supabase.auth.setSession({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
      });

      if (!isMounted) return;

      if (sessionError) {
        setError("Authentication failed while storing your session. Please try again.");
        return;
      }

      dispatch(setSessionUser(session));

      const userId = session?.user?.id || user?.user_id || user?.id;
      let resolvedUser = user;
      if (userId) {
        const profileResponse = await getUserById(userId);
        if (profileResponse?.success && profileResponse?.data) {
          resolvedUser = profileResponse.data;
        }
      }

      dispatch(setUser(resolvedUser));
      if (resolvedUser?.profilePicture) {
        localStorage.setItem("pdp", resolvedUser.profilePicture);
      }

      const destination = isNewUser
        ? "/add-social-links"
        : nextFromQuery || nextFromApi || "/";

      navigate(destination, {
        replace: true,
      });
    };

    handleGoogleCallback();

    return () => {
      isMounted = false;
    };
  }, [dispatch, navigate, searchParams]);

  if (!error) return <Loading />;

  return (
    <div className="auth-bg pt-12 p-fixed" style={{ height: "100%", width: "100dvw", top: 0, left: 0 }}>
      <div className="auth-container pb-40 h-100 d-flex f-column aic jcc">
        <p className="error-message ta-center mb-24">{error}</p>
        <button
          type="button"
          className="btn red-btn btn-full-v"
          onClick={() => navigate("/login")}
          aria-label="Back to login"
        >
          Back to login
        </button>
      </div>
    </div>
  );
}
